import React, { PropsWithChildren } from "react";
import sass from "../desc.module.sass";

interface IAccordionProps extends PropsWithChildren {}
const Accordion: React.FC<IAccordionProps> = ({ children }) => {
	return (
		<div data-comment-false={true} className={sass.accordion}>
			{children}
		</div>
	);
};

export default Accordion;
